import { Flex } from '@chakra-ui/react'
import { useSettingsState } from '~/atoms/SettingsState'
import { useCallQueue } from '~/hooks/useCallQueue'
import WebPhoneView from '~/pages/WebPhone/WebPhoneView'

import { phoneColorKeys } from './componentStyles/_colors'
import { OnboardingView } from './OnboardingView'
import { StatusDisplay } from './StatusDisplay'

const { WebPhonePage: PageColors } = phoneColorKeys.Phone

const WebPhonePage = () => {
  const { canUseWebPhone } = useSettingsState()

  const { setWebPhoneEnabled } = useSettingsState()

  const { currentCustomStatus, formattedTime } = useCallQueue()

  const handleActivateButtonClick = () => {
    setWebPhoneEnabled(true)
  }

  return (
    <Flex
      h="full"
      w="full"
      justify="center"
      bg={PageColors.Background}
      flex={'1 0 0'}
      alignSelf={'stretch'}
    >
      {canUseWebPhone && (
        <StatusDisplay
          currentCustomStatus={currentCustomStatus}
          formattedTime={formattedTime}
        />
      )}
      {canUseWebPhone &&
        (!currentCustomStatus ||
          currentCustomStatus?.availability == 'Online') && <WebPhoneView />}
      {!canUseWebPhone && (
        <OnboardingView onActivateButtonClick={handleActivateButtonClick} />
      )}
    </Flex>
  )
}

export default WebPhonePage
